import script from "./prestoreOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./prestoreOrder.vue?vue&type=script&setup=true&lang=js"

import "./prestoreOrder.vue?vue&type=style&index=0&id=d9f32cac&lang=scss"

const __exports__ = script;

export default __exports__